import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="table"
export default class extends Controller {
  static targets = ["checkbox", "parentCheckbox"];

  toggleRow(_event) {
    if (this.noRowSelected()) {
      this.parentCheckboxTarget.checked = false;
      this.parentCheckboxTarget.indeterminate = false;
    } else {
      this.parentCheckboxTarget.checked = this.allRowsSelected();
      this.parentCheckboxTarget.indeterminate = !this.allRowsSelected();
    }
  }

  toggleAllRows(event) {
    const parentCheckbox = event.target;

    if (parentCheckbox.checked) {
      this.selectAllRows();
    } else {
      this.deselectAllRows();
    }
  }

  selectAllRows() {
    this.checkboxTargets.forEach((cb) => (cb.checked = true));
  }

  deselectAllRows() {
    this.checkboxTargets.forEach((cb) => (cb.checked = false));
  }

  noRowSelected() {
    return this.checkboxTargets.every((cb) => cb.checked === false);
  }

  allRowsSelected() {
    return this.checkboxTargets.every((cb) => cb.checked === true);
  }
}
